import Vue from 'vue'
import Vuex from 'vuex'
import {
  API
} from "aws-amplify";

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: null,
    records: [],
    error: null
  },
  getters: {
    user: state => {
      return state.user
    },
    isSignin: state => {
      return state.user !== null
    },
    records: state => {
      return state.records
    },
    chartData: (state) => {
      return state.records.filter(row => {
        return row.selected;
      })
    },
    peoples: state => {
      return state.records
        .filter(row => {
          return (row.category === "people")
        })
    },
    organizations: state => {
      return state.records
        .filter(row => {
          return (row.category === "organization")
        })
    },
    eventData: function (state) {
      var list = state.records.filter((row) => {
        return row.selected
      }).map(function (row, i) {
        return row.events.map(function (event) {
          return {
            title: row.title,
            content: event.content,
            top: row.top,
            start: event.start,
            baseIndex: i
          }
        });
      })
      // flatten Array
      return Array.prototype.concat.apply([], list);
    },
    areaStartYear: function (state) {
      // 全データにおける歴史開始年の最小値を求める, -10ぶんをマージン
      var v = state.records.filter((row) => {
        return row.selected
      }).map((row) => {
        return row.start
      })
      return v.length > 0 ? Math.min.apply(null, v) - 10 : 0
    },
    areaEndYear: function (state) {
      // 全データにおける歴史終了年の最大値を求める. +10年ぶんをマージン
      var v = state.records.filter((row) => {
        return row.selected
      }).map((row) => {
        return row.end === undefined ? (new Date()).getFullYear() : row.end;
      })
      if (v.length <= 0) {
        return 0
      }

      // 選択されたレコードのendが全て0だった場合は、現年度を終了年とし、マージン+10を加算
      return (Math.max.apply(null, v) === 0 ? (new Date()).getFullYear() : Math.max.apply(null, v)) + 10
    },
    error: state => state.error,
  },
  mutations: {
    setUser(state, user) {
      state.user = user;
    },
    setRecords(state, records) {
      state.records = records.map(record => {
        record["selected"] = false;
        return record;
      });
    }
  },
  actions: {
    async scanRecords({
      commit
    }) {
      try {
        let apiName = "timeaxis";
        let path = "/axis";
        const records = await API.get(apiName, path);
        commit("setRecords", records);
      } catch (ex) {
        console.error(ex);
      }
    },
    async postRecord({
      commit
    }, params) {
      try {
        const result = await API.post("timeaxis", "/axis", params);
        await this.dispatch("scanRecords");
        return result;
      } catch (ex) {
        console.error(ex);
      }
    },
    async putRecord({
      commit
    }, params) {
      try {
        const result = await API.put("timeaxis", "/axis", params);
        await this.dispatch("scanRecords");
        return result;
      } catch (ex) {
        console.error(ex);
      }
    },
    async deleteRecord({
      commit
    }, record) {
      try {
        let apiName = "timeaxis";
        let path = "/axis/object/" + record.id;
        const result = await API.del(apiName, path);
        await this.dispatch("scanRecords");
      } catch (ex) {
        console.error(ex);
      }
    },
    onSelectStateChangedAsync({
      commit
    }, people) {
      // 1つ目のチェックonでチャートが描画されない問題への対応
      // people.selectedの変更がgetters.chartDataに反映されるまで0.2秒待つ
      return new Promise((resolve) => {
        setTimeout(() => {
          people.selected = !people.selected
          resolve()
        }, 200)
      })
    }
  }
})